<template>
  <div
    id="wrapper"
    class="wrapper"
    :class="{ 'nav-open': $sidebar.showSidebar }"
  >
    <ReleasePopup
      v-if="document"
      :show="showReleasePopupModal"
      :document="document"
      @closeModalReleasePopup="closeModalReleasePopup"
    />
    <notifications></notifications>
    <dashboard-navbar :show="true"></dashboard-navbar>

    <div id="preloader" class="global-preloader" v-if="load">
      <div class="preloader-content">
        <img
          src="~rhomtrip_assets/src/img/icons/rhomtrip-icon.gif"
          alt="Loading..."
          class="preloader-image"
        />

        <div class="preloader-bar-container">
          <div
            class="preloader-bar"
            :style="{ width: progressBarWidth + '%' }"
          ></div>
        </div>
        <p class="preloader-text" data-aos="fade">Loading...</p>
      </div>
    </div>

    <side-bar>
      <template slot-scope slot="links">
        <img
          src="~rhomtrip_assets/src/img/brand/icon-rhomtrip-150x158.png"
          alt="RhomTrip"
          class="logo-icon"
        />

        <div class="nav-item text-center d-lg-block d-md-none">
          <span
            @click="openSidebar()"
            class="icon-open-close"
            :class="{
              'close-side': verticalSidebar == false,
              'open-side': verticalSidebar == true,
            }"
            ><i
              :class="{
                'flaticon-menu-3 ': verticalSidebar == false,
                'flaticon-menu-2': verticalSidebar == true,
              }"
            ></i
          ></span>
        </div>

        <sidebar-item
          :link="{
            name: 'Dashboards',
            icon: 'flaticon-trend',
            path: '/dashboard',
          }"
          v-if="hasUserAccess(userRole, [ROLES.SUPER_ADMIN, ROLES.ADMIN])"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Reservations',
            icon: 'flaticon-calendar',
            path: '/reservations',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Quotes',
            icon: 'flaticon-tools-document',
            path: '/quotes',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Customers',
            icon: 'flaticon-employees',
            path: '/customers',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Partners',
            icon: 'flaticon-support',
            path: '/partners',
            badge: getBadgeForPartnersItem(badges),
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Suppliers',
            icon: 'flaticon-businessman-1',
            path: '/suppliers',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Areas',
            icon: 'flaticon-radar',
            path: '/coverage-areas',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        ></sidebar-item>

        <sidebar-item
          :link="{
            name: 'Vehicles',
            icon: 'flaticon-car',
            path: '/vehicles',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Rates',
            icon: 'flaticon-bold-list',
            path: '/rates',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Experiences',
            icon: 'flaticon-tools-traveling',
            path: '',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
              ROLES.USER,
              ROLES.SUPPORT,
            ])
          "
        >
          <sidebar-item
            :link="{
              name: 'In-House',
              path: '/experiences/rhomtrip',
            }"
            v-if="
              hasUserAccess(userRole, [
                ROLES.SUPER_ADMIN,
                ROLES.ADMIN,
                ROLES.MANAGER,
                ROLES.USER,
                ROLES.SUPPORT,
              ])
            "
          ></sidebar-item>

          <sidebar-item
            :link="{
              name: 'Ventrata',
              path: '/experiences/ventrata',
            }"
            v-if="
              hasUserAccess(userRole, [
                ROLES.SUPER_ADMIN,
                ROLES.ADMIN,
                ROLES.MANAGER,
                ROLES.USER,
                ROLES.SUPPORT,
              ])
            "
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Team',
            icon: 'flaticon-costumer',
            path: '/team',
          }"
          v-if="hasUserAccess(userRole, [ROLES.SUPER_ADMIN, ROLES.ADMIN])"
        ></sidebar-item>
        <sidebar-item
          :link="{
            name: 'Tools',
            icon: 'flaticon-tools-settings',
            path: '/tools',
          }"
          v-if="
            hasUserAccess(userRole, [
              ROLES.SUPER_ADMIN,
              ROLES.ADMIN,
              ROLES.MANAGER,
            ])
          "
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="80" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <globalFooter class="global-foot"></globalFooter>
    </div>
  </div>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import globalFooter from "@/layouts/GlobalFooter";
import Pusher from "pusher-js";
import ReleasePopup from "@/components/PopupRelease.vue";
import DashboardNavbar from "@/layouts/DashboardNavbar.vue";
import ContentFooter from "@/layouts/ContentFooter.vue";
import DashboardContent from "@/layouts/Content.vue";
import { FadeTransition } from "vue2-transitions";
import { mapGetters, mapActions, mapMutations } from "vuex";

import { ROLES } from "@/helpers/commons.helpers";
import { ProfilesAPI, MetricsAPI, DocumentsAPI } from "@/core/api";
import { hasUserAccess } from "@/core/services/security.services";

/**
 * Checks if an element with the given class exists in the DOM.
 * @param {string} className - The class name to search for.
 * @returns {boolean}
 */
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

/**
 * Initializes PerfectScrollbar on the given class.
 * Retries if the element is not yet available.
 * @param {string} className - The class name to initialize the scrollbar on.
 */
function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  name: "DashboardLayout",
  data() {
    return {
      verticalSidebar: false,
      badges: null,
      pusher: null,
      subscribeChannel: null,
      progress: 0,
      showReleasePopupModal: true,
      document: null,
      ROLES,
    };
  },
  watch: {
    /**
     * Watches for changes in the load state and simulates loading progress.
     */
    load: {
      handler: function (current, old) {
        if (current) {
          this.progress = 0;
          this.simulateLoading();
        }
      },
      deep: true,
    },
  },
  async created() {
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER,
    });
    this.subscribeChannel = this.pusher.subscribe("rhombuss");
    this.initScrollbar();
    this.getSesion();
    if (this.sesion) {
      await this.getSettings();
      const user = await this.fetchUserProfile(
        this.sesion.id,
        this.userRole,
        this.sesion.account_type.type,
        this.sesion.token
      );
      if (user) {
        this.setProfile(user);
      }
      this.getCustomerOptions();
      this.getGlobalCountries();
      this.getBranchesOptions();
      this.badges = await this.getBadges();
      this.watchCustomersUpdates(
        this.subscribeChannel,
        "customers",
        this.getCustomerOptions
      );
      this.watchReleaseUpdates(this.subscribeChannel, "new-release");
    }
  },
  async mounted() {
    let systemInfo = await this.getCurrentReleaseByApp("INTERNAL");
    if (systemInfo) {
      this.setSystemInfo({
        name: this.systemInfo.name,
        year: this.systemInfo.year,
        ...systemInfo,
      });
      let latestNewsAvailable = await this.checkViewedRelease(
        "INTERNAL",
        this.systemInfo.release.version,
        this.sesion.id
      );
      this.setLatestNewsAvailable(latestNewsAvailable);
      this.handleAppVersion(systemInfo);
    }
  },
  methods: {
    // Reusing the imported hasUserAccess function
    hasUserAccess,
    /**
     * Fetches the user profile based on user ID and token.
     * @param {number} userId - The ID of the user.
     * @param {string} token - The authentication token.
     * @returns {Object} - The user profile data or an error object.
     */
    async fetchUserProfile(userId, token) {
      try {
        let { data } = await ProfilesAPI.getProfileUser(userId, token);
        if (data.status) {
          let user = data.data;
          return {
            first_name: user.personal_info.first_name,
            last_name: user.personal_info.last_name,
            url_picture: user.profile.image,
            status: true,
          };
        } else {
          return {
            first_name: "",
            last_name: "",
            url_picture: "",
            status: false,
          };
        }
      } catch (error) {
        return {
          first_name: "",
          last_name: "",
          url_picture: "",
          status: false,
        };
      }
    },
    /**
     * Initializes the custom scrollbar.
     */
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("scrollbar-inner");
        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    /**
     * Toggles the visibility of the sidebar.
     */
    openSidebar() {
      this.verticalSidebar = !this.verticalSidebar;
      let docClasses = document.body.classList;
      if (this.verticalSidebar === true) {
        docClasses.add("g-sidenav-pinned");
      } else {
        docClasses.remove("g-sidenav-pinned");
      }
    },
    /**
     * Fetches badges data from the server.
     * @returns {Object|null} - The badges data or null if an error occurs.
     */
    async getBadges() {
      try {
        let { data } = await MetricsAPI.getBadges(this.sesion.token);
        if (data.status) {
          return data.data;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    /**
     * Determines if the "Partners" sidebar item should display a badge.
     * @param {Object} badges - The badges data.
     * @returns {boolean} - True if the badge should be displayed, false otherwise.
     */
    getBadgeForPartnersItem(badges) {
      if (badges) {
        if (badges.partners) {
          return badges.partners.approval > 0;
        }
        return false;
      }
      return false;
    },
    /**
     * Subscribes to customer updates on the given channel and event.
     * @param {Object} channel - The Pusher channel to subscribe to.
     * @param {string} event - The event name to listen for.
     * @param {Function} callback - The callback function to execute when the event is triggered.
     */
    watchCustomersUpdates(channel, event, callback) {
      channel.bind(event, (data) => {
        let roles = [
          ROLES.SUPER_ADMIN,
          ROLES.ADMIN,
          ROLES.MANAGER,
          ROLES.USER,
          ROLES.SUPPORT,
        ];
        if (roles.includes(this.userRole)) {
          if (data.type === "admin") {
            callback();
          }
        }
      });
    },
    /**
     * Subscribes to release updates on the given channel and event.
     * @param {Object} channel - The Pusher channel to subscribe to.
     * @param {string} event - The event name to listen for.
     */
    watchReleaseUpdates(channel, event) {
      channel.bind(event, (data) => {
        let apps = ["INTERNAL"];
        if (apps.includes(data.data.app)) {
          this.setLatestNewsAvailable(true);
          this.setSystemInfo({
            name: this.systemInfo.name,
            year: this.systemInfo.year,
            ...data.data,
          });
          this.handleAppVersion(data.data);
        }
      });
    },
    /**
     * Fetches the current release information for the specified app.
     * @param {string} app - The application identifier.
     * @returns {Object|null} - The current release data or null if an error occurs.
     */
    async getCurrentReleaseByApp(app) {
      try {
        let { data } = await DocumentsAPI.getCurrentReleaseByApp(
          app,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    /**
     * Checks if the user has viewed the specified release version.
     * @param {string} app - The application identifier.
     * @param {string} releaseVersion - The release version to check.
     * @param {number} userId - The ID of the user.
     * @returns {boolean} - True if the release has not been viewed, false otherwise.
     */
    async checkViewedRelease(app, releaseVersion, userId) {
      try {
        let { data } = await DocumentsAPI.checkViewedRelease(
          app,
          releaseVersion,
          userId,
          this.sesion.token
        );
        if (data.status) {
          return !data.data.wasViewed;
        }
        return false;
      } catch (error) {
        return false;
      }
    },

    /**
     * Simulates a loading progress bar.
     */
    simulateLoading() {
      const interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 10;
        } else {
          clearInterval(interval);
        }
      }, 500);
    },
    /**
     * Opens the release popup modal.
     */
    openModalReleasePopup() {
      this.showReleasePopupModal = true;
    },
    /**
     * Closes the release popup modal.
     * @param {boolean} status
     */
    closeModalReleasePopup(status) {
      this.showReleasePopupModal = status;
    },
    /**
     * Handles application version changes and triggers the release popup if needed.
     * @param {Object} systemInfo
     */
    handleAppVersion(systemInfo) {
      if (systemInfo && systemInfo.release) {
        const currentVersion = systemInfo.release.version;
        const storedVersion = localStorage.getItem("appVersion");
        if (storedVersion && storedVersion !== currentVersion) {
          this.document = systemInfo;
          this.openModalReleasePopup();
        } else {
          if (!storedVersion) {
            localStorage.setItem("appVersion", currentVersion);
          }
        }
      }
    },
    ...mapActions([
      "getSesion",
      "getGlobalCountries",
      "getBranchesOptions",
      "getCustomerOptions",
      "getSettings",
    ]),
    ...mapMutations(["setProfile", "setSystemInfo", "setLatestNewsAvailable"]),
  },
  destroyed() {
    if (this.pusher) {
      this.pusher.disconnect();
    }
  },
  computed: {
    ...mapGetters([
      "sesion",
      "userRole",
      "load",
      "profile",
      "module",
      "systemInfo",
    ]),
    progressBarWidth() {
      return this.progress;
    },
  },
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
    globalFooter: globalFooter,
    ReleasePopup,
  },
};
</script>
